export default {

	getDDSScoresAreVisible: (state) => {
		return state.DDSScoresAreVisible;
	}

};
